export const licenseKey = process.env.REACT_APP_DEVEXPRESS_LICENSE_KEY;
// Export the license key
